/**
 * All Classes scripts required should be included here.
 *
 * This is the file that Webpack is compiling into class.[hash].js
 */

import "./sass/product.scss";
import "./sass/course-search.scss";
import "./sass/course-search-calendar.scss";

import productDates from "./js/product-dates";

const productDatesInstance = new productDates();

$(document).ready(() => {
  productDatesInstance.init();
});
